import React from 'react';

import './CustomScrollableArea.styl';

const CustomScrollableArea = ({ children }) => {
  return <div className="scroll-container">{children}</div>;
};

export { CustomScrollableArea };
